import __vue_component__ from './ContentLoader.vue.js';

//
var script = {
  name: 'FolderPathLoader',
  components: {
    ContentLoader: __vue_component__
  },
  props: {
    size: {
      type: String,
      default: 'normal'
    }
  },
  computed: {
    loaderHeight() {
      return this.size === 'small' ? 17 : 20;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/ContentLoader/FolderPathLoader.vue_rollup-plugin-vue=script.js